// extracted by mini-css-extract-plugin
export var createdDate = "_na-1";
export var divider = "_na-2";
export var headerDivider = "_na-3";
export var messagesCard = "_na-0";
export var messagesContainer = "_na-6";
export var messagesContainerWrapper = "_na-4";
export var showLeftPanelButton = "_na-8";
export var topButtons = "_na-7";
export var withPadding = "_na-5";